
import { useQuery } from '@tanstack/react-query';
import { UserProfile } from '@/types/database.types';
import { supabase } from '@/integrations/supabase/client';

export const useAllProfiles = () => {
  return useQuery({
    queryKey: ['profiles'],
    queryFn: async () => {
      try {
        // Use the edge function to get both profile data and auth data (including emails)
        const { data, error } = await supabase.functions.invoke('invite-user', {
          body: {
            action: 'fetchUsersWithAuth'
          }
        });

        if (error) throw error;
        
        if (!data || !data.profiles) {
          throw new Error('No profiles data returned');
        }

        return data.profiles as (UserProfile & { email: string, user_metadata?: any })[];
      } catch (error) {
        console.error("Error fetching profiles:", error);
        throw error;
      }
    },
    refetchOnWindowFocus: false,
  });
};
